import { compose } from '@reduxjs/toolkit';
import { fetchAllZonesReducer } from './fetchAllZones';

export const extraReducers = compose(fetchAllZonesReducer);
export { fetchAllZones } from './fetchAllZones';
